module.exports = __webpack_public_path__ + "media/CUBE_montaggio_1.7ca84414.mp4";